import * as React from 'react';
import { Dialog } from '@shared/ui-react/Dialog';
import { Button } from '@shared/ui-react/Button';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { BcfVersion, PageStateService } from '@shared/user-state/PageStateService';

/**
 * BCF version picker shown before the given saved views download as a single .bcfzip. One
 * download button per version, like LogpointsDownloadDialog. 2.1 is listed first: it is the
 * version the mainstream CAD-plugin BCF managers (Solibri, Revit, BIMcollab ZOOM) read and
 * write; 3.0 is the current buildingSMART standard for viewers that ask for it.
 */
export const BcfExportDialog = {
    open: (items: IPageState[]) => {
        ReactUtils.safeRender(<BcfExportDialogComponent items={items} />, document.getElementById('react-portal-root'));
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};

const VERSIONS: { version: BcfVersion; label: string; hint: string }[] = [
    { version: '2.1', label: __('js_saved_views.export_bcf.version_21'), hint: __('js_saved_views.export_bcf.version_21_hint') },
    { version: '3.0', label: __('js_saved_views.export_bcf.version_30'), hint: __('js_saved_views.export_bcf.version_30_hint') },
];

const BcfExportDialogComponent: React.FC<{ items: IPageState[] }> = ({ items }) => {
    const onExport = (version: BcfVersion) => {
        // The export is a plain browser download (GET navigation), so there is nothing to await.
        PageStateService.exportBcf(
            items.map(item => item.uuid),
            version
        );
        BcfExportDialog.close();
    };

    const count = items.length > 1 ? ` (${items.length})` : '';

    return (
        <Dialog title={__('js_saved_views.export_bcf.title')} onClose={BcfExportDialog.close} closeOnEsc={true}>
            <div className='padded flex-column min-w-[420px]'>
                <p className='mt-0'>{__('js_saved_views.export_bcf.description')}</p>
                {VERSIONS.map(option => (
                    <div key={option.version} className='flex-row ai-center gap-half my-ik-xs'>
                        <Button icon='download' className='ik-button-primary whitespace-nowrap' onClick={() => onExport(option.version)}>
                            {option.label}
                            {count}
                        </Button>
                        <span className='text-[0.9em] text-ik-text-weak'>{option.hint}</span>
                    </div>
                ))}
            </div>
        </Dialog>
    );
};
